import type { TError, TTopContributorsResponse } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export const useGetTopContributorsQueryKey = (spaceId: string) => [ENTITY, 'widgets', spaceId, 'top-contributors'];

/**
 * Hook to fetch the members with the most replies in a space this calendar
 * month (name + avatar + reply count).
 *
 * @param spaceId - Feed space ID (UUID)
 */
export const useGetTopContributors = (spaceId: string) => {
  return useQuery<TTopContributorsResponse, TError>({
    queryKey: useGetTopContributorsQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TTopContributorsResponse>(
        `/community-hub/spaces/${spaceId}/widgets/top-contributors`,
      );
      return res.data;
    },
    enabled: !!spaceId,
    staleTime: 5 * 60 * 1000, // 5 minutes — matches the API-side cache window
  });
};
